<template>
	<div>
		<div class="routerBranchMenu">
			<router-link class="routerBranchMenuItem" to="/branch/singapore"><p class="routerBranchMenuItemTit">Companies based in Singapore</p></router-link>
			<router-link class="routerBranchMenuItem" to="/branch/maritime"><p class="routerBranchMenuItemTit">Global Maritime</p></router-link>
			<router-link class="routerBranchMenuItem" to="/branch/equip"><p class="routerBranchMenuItemTit">Global Equipment</p></router-link>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: "Branch"
}
</script>

<style scoped>
.routerBranchMenu{ font-family: 'SiYuan-Light', sans-serif; }
	@media (max-width: 380px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerBranchMenu{ height: 70px; border-bottom: 1px solid #e1edff; width: 96%; display: flex; flex-wrap: nowrap; }
		.routerBranchMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 33%; display: block; text-align: center; }
		.routerBranchMenuItem:hover{ color: #07c7f1; }
		.routerBranchMenuItemTit{ transition: all 0.2s linear; display: flex; align-items: center; justify-content: center; height: 70px; margin: 0; }
	}
	@media (min-width: 380px) and (max-width: 465px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerBranchMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 96%; display: flex; flex-wrap: nowrap; }
		.routerBranchMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 33%; display: block; text-align: center; }
		.routerBranchMenuItem:hover{ color: #07c7f1; }
		.routerBranchMenuItemTit{ transition: all 0.2s linear; display: flex; align-items: center; justify-content: center; height: 36px; margin: 0; }
	}
	@media (min-width: 465px) and (max-width: 726px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerBranchMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 96%; display: flex; flex-wrap: nowrap; }
		.routerBranchMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 33%; display: block; text-align: center; }
		.routerBranchMenuItem:hover{ color: #07c7f1; }
		.routerBranchMenuItemTit{ transition: all 0.2s linear; display: flex; align-items: center; justify-content: center; height: 36px; margin: 0; }
	}
	@media (min-width: 726px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerBranchMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 690px; display: flex; flex-wrap: nowrap; }
		.routerBranchMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 33.3%; display: block; text-align: center; }
		.routerBranchMenuItem:hover{ color: #07c7f1; letter-spacing: 1px; }
		.routerBranchMenuItemTit{ transition: all 0.2s linear; display: block; height: 36px; line-height: 46px; margin: 0; }
	}
</style>